import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';

interface GeneralReportScheduleReportsWarningContentSignature {
  Args: {
    errorMessages: unknown;
    successMessages: unknown;
    warningMessages: unknown;
  };
}

const GeneralReportScheduleReportsWarningContent = <template>
  {{! @glint-nocheck: not typesafe yet }}
  {{#if @successMessages.length}}
    <div
      class="reports-status-section border-general-success-100 bg-general-success-200 text-success-default"
    >
      <span class="reports-status-section__title">
        {{t "reports.general_success"}}
      </span>
      <ul class="reports-status-section__list">
        {{#each @successMessages as |message|}}
          <li class="reports-warning-item">
            {{message.report.recipient.email}}
          </li>
        {{/each}}
      </ul>
    </div>
  {{/if}}
  {{#if @warningMessages.length}}
    <div
      class="reports-status-section border-general-warning-100 bg-general-warning-200 text-warning-default"
    >
      <span class="reports-status-section__title">
        {{t "reports.error_for_users"}}
      </span>
      <ul class="reports-status-section__list">
        {{#each @warningMessages as |message|}}
          <li class="reports-warning-item">
            {{message.report.recipient.email}}
          </li>
        {{/each}}
      </ul>
    </div>
  {{/if}}
  {{#if @errorMessages.length}}
    <div
      class="reports-status-section border-general-critical-100 bg-general-critical-200 text-critical-default"
    >
      <span class="reports-status-section__title">
        {{t "reports.general_error"}}
      </span>
      <ul class="reports-status-section__list">
        {{#each @errorMessages as |message|}}
          <li class="reports-warning-item">
            {{message.report.recipient.email}}
          </li>
        {{/each}}
      </ul>
    </div>
  {{/if}}
</template> satisfies TOC<GeneralReportScheduleReportsWarningContentSignature>;

export default GeneralReportScheduleReportsWarningContent;
